module.exports = __webpack_public_path__ + "img/hierarchy-5.b9861f51.svg";